<template>
  <card class="card-stats">
    <div class="statistics statistics-horizontal">
      <div class="info info-horizontal">
        <div class="row appointment-id justify-content-between pl-2 pr-2" style="margin-bottom: 15px;">
          <div class="col-8" style="font-size: 1.2em; font-weight: 600; padding:0;">
            <span v-if="appointment.patient">{{ appointment.patient.firstName }}
              {{ appointment.patient.lastName }}</span>
          </div>
          <div v-if="appointment.referenceId" class="col-4" style="font-size: small; font-weight: 600; padding-right: 0; text-allign: end;">
            <span style="margin-inline-end: 0.5em">
              <i class="fas fa-hashtag"></i>
            </span>
            <span>{{ appointment.referenceId }}</span>
          </div>
        </div>
        <div class="row visit-details details">
          <div class="col-3 col-md-3 pr-0">
            <div class="row">
              <div class="col-12 text-center">
                <img :src="avatarImage" class="picture-src" style="
                    width: 100px;
                    border-radius: 50%;
                    outline-color: transparent;
                  " />
                <br />
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center" v-if="appointment.patient">
                <div v-if="appointment.patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                  <span>
                    <i class="fa fa-mars"></i>
                  </span>
                </div>
                <div v-if="appointment.patient.gender == 'female'" style="color: rgb(235, 63, 157)">
                  <span>
                    <i class="fa fa-venus"></i>
                  </span>
                </div>
                <div v-if="appointment.patient.gender == 'others'" style="color: rgb(33, 243, 208)">
                  <span>
                    <i class="fa fa-transgender-alt"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-9 col-md-9 right">
            <slot>
              <div class="row" v-if="user.roles.includes('doctor') && appointment.attendant">
                <div class="col-md-3 col-3 text-center">
                  <span>
                    <i class="fas fa-user-nurse"></i>
                  </span>
                </div>
                <div class="col-md-9 col-9 pl-0">
                  <span>{{ appointment.attendant.firstName }}
                    {{ appointment.attendant.lastName }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 col-3 text-center">
                  <span>
                    <i class="fa fa-calendar-check"></i>
                  </span>
                </div>
                <div class="col-md-6 col-6 pl-0">
                  <span>{{
                    getConsultationType(appointment.consultationType, appointment.appointmentType)
                  }}</span>
                </div>
                <div v-if="unreadMessagesCount > 0 && chatMode" style="position: absolute;inset-inline-end: 1em;display: flex;justify-content: center;align-items: start;">
                  <span style="color: white;position: absolute;font-size: 0.7em;margin-top: 0.4em;">
                    {{unreadMessagesCount}}
                  </span>
                  <span>
                    <i class="far fa-comment-alt" style="font-weight: 900;color: var(--color-primary);font-size: 2em;"></i>
                  </span>
                </div>
              </div>
              <div class="row" v-if="appointment.appointmentType == 'Discussion'">
                <div class="col-md-3 col-3 text-center">
                  <span>
                    <i class="fa fa-clock"></i>
                  </span>
                </div>
                <div class="col-md-8 col-8 pl-0">
                  <span>{{
                      getAppointmentDatetime(new Date(appointment.created))
                  }}</span>
                </div>
              </div>
              <div class="row" v-if="appointment.patient && appointment.patient.patientId">
                <div class="col-md-3 col-3 text-center">
                  <span>
                    <i class="fa fa-info-circle"></i>
                  </span>
                </div>
                <div class="col-md-9 col-9 pl-0">
                  <span>{{ appointment.patient.patientId }}</span>
                </div>
              </div>
              <div class="row" v-if="appointment.patient && appointment.patient.dob">
                <div class="col-md-3 col-3 text-center">
                  <span>
                    <i class="fa fa-birthday-cake"></i>
                  </span>
                </div>
                <div class="col-md-9 col-9 pl-0">
                  <span>{{ getAge(appointment.patient.dob) }}</span>
                </div>
              </div>
              <div class="row" v-if="appointment.patient && appointment.patient.mobileNumber && appointment.patient.mobileNumber.length>0">
                <div class="col-md-3 col-3 text-center">
                  <span>
                    <i class="fa fa-mobile"></i>
                  </span>
                </div>
                <div class="col-md-9 col-9 pl-0">
                  <span>{{ appointment.patient.mobileNumber }}</span>
                </div>
              </div>
              <div class="row" v-if="appointment.reason">
                <div class="col-md-3 col-3 text-center">
                  <span>
                    <i class="fa fa-question"></i>
                  </span>
                </div>
                <div class="col-md-9 col-9 pl-0">
                  <span>{{ appointment.reason }}</span>
                </div>
              </div>
              <div class="row" v-if="appointment.appointmentType == 'Scheduled'">
                <div class="col-md-3 col-3 text-center">
                  <span>
                    <i class="fa fa-clock-o"></i>
                  </span>
                </div>
                <div class="col-md-9 col-9 pl-0">
                  <span>{{
                    getAppointmentDatetime(appointment.scheduledTimestamp.start)
                  }}</span>
                </div>
              </div>
            </slot>
          </div>
        </div>
      </div>
      <div v-if="appointment.appointmentType == 'Discussion' &&  appointment.latestStatus != 'InProgress'" style="position: absolute;top: -0.5em;right: -0.5em;">
        <div class="call-ripple">
          <span style="display: flex;justify-content: center;align-items: center;"><i class="fas fa-phone-alt" style="font-size: 0.2em;"></i></span>
        </div>
      </div>
    </div>
    <div class="stats text-center" slot="footer">
      <n-button type="primary" class="btn-padding btn-simple mr-2" round @click.native="declineVisit(appointment)" v-if="!chatMode">
        <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
        {{ $t("message.Decline") }}
      </n-button>
      <!-- added show view button on paused. -->
      <n-button type="primary" class="btn-padding mr-2" round @click.native="viewAppointmentDetails(appointment)" v-if="
          (appointment.latestStatus == 'Assigned' ||
          appointment.latestStatus == 'Paused') &&
          appointment.latestStatus != 'InProgress'
          ">
        <i slot="label" class="fa fa-eye"></i>
        {{ $t("message.View") }}
      </n-button>
      <n-button type="primary" class="btn-padding  mr-2 mb-2 mt-2" round @click.native="join(appointment)" v-if="
          appointment.latestStatus != 'Completed' &&
          (appointment.appointmentType != 'Scheduled' ||
            (appointment.appointmentType == 'Scheduled' &&
              (appointment.latestStatus == 'Assigned' ||
                appointment.latestStatus == 'InProgress' || appointment.latestStatus == 'Paused')))
        ">
        <i slot="label" class="now-ui-icons arrows-1_minimal-right"></i>
        {{ $t("message.Join") }}
      </n-button>
    </div>

    <loading :active.sync="LOADING" :can-cancel="false" :is-full-page="true" color="#2ca8ff">
      <template v-slot:after>
        <h5 class="text-info">{{ loaderText }}</h5>
      </template>
    </loading>
  </card>
</template>

<script>
import avatarImage from "@/assets/img/proAvatar.png";
import moment from "moment-timezone";
import socket from "@/services/socket";

export default {
  name: "appointment-card",

  data() {
    return {
      avatarImage,
      loader: null,
      LOADING: false,
      loaderText: "",
      setupResponse: null,
    };
  },

  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    settings() {
      return this.$store.state.settings;
    },
    chatMode() {
      if (
        this.appointment.consultationType == "telemed-direct" &&
        this.settings.directTelemedicine.consultancyParadigm == "chat"
      ) {
        return true;
      } else if (this.settings.consultancyParadigm == "chat") {
        return true;
      } else {
        return false;
      }
    },
    unreadMessagesCount() {
      if (
        this.appointment.unreadMessagesCount &&
        this.appointment.unreadMessagesCount.hasOwnProperty(this.user._id)
      ) {
        return this.appointment.unreadMessagesCount[this.user._id];
      } else {
        return 0;
      }
    },
  },

  props: ["appointment"],

  methods: {
    getFormattedDob(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getConsultationType(consultationType, appointmentType) {
      let label =
        consultationType == "inperson"
          ? this.$t("message.InPerson")
          : this.$t("message.Telemedicine");

      if (appointmentType && appointmentType == "Discussion") {
        return (label =
          label +
          " (" +
          this.$t("message.Discussion") +
          ")");
      } else {
        return label;
      }
    },

    getAppointmentDatetime(timestamp) {
      return moment(Number(timestamp)).format("DD-MM-YYYY, hh:mm a");
    },

    async checkEndpointStatus() {
      let ep = await this.$store.dispatch(
        "getEndpoint",
        this.user.endpoint.name
      );
      return ep.status;
    },

    async join(appt) {
      try {
        this.LOADING = true;
        this.loaderText = "";
        let endponitStatus = await this.checkEndpointStatus();
        if (endponitStatus == "Busy") {
          this.LOADING = false;
          // show ep is busy
          swal.fire({
            title: this.$t("message.Endpoint Busy"),
            type: "info",
            closeOnConfirm: true,
          });
        } else {
          let telemedPage = "telemed";
          if (appt.appointmentType == "Discussion") {
            telemedPage = "telemeddiscussion";
          }
          if (
            appt &&
            (appt.appointmentType == "Live" ||
              appt.appointmentType == "Discussion")
          ) {
            if (
              appt.latestStatus == "Assigned" ||
              appt.latestStatus == "InProgress" ||
              appt.latestStatus == "Paused"
            ) {
              //If appointment is for speciality
              if (!appt.provider || !appt.provider.providerId) {
                var provider = {
                  providerId: this.user._id,
                  username: this.user.username,
                  firstName: this.user.firstName,
                  lastName: this.user.lastName,
                  specialityText: this.user.specialityText,
                  timezone: this.user.timezone,
                  description: this.user.description,
                  UIN: this.user.UIN,
                };

                //Get appointment's endpoint details
                let endpoint = await this.$store.dispatch(
                  "getEndpoint",
                  appt.endpoint
                );
                if (
                  endpoint &&
                  endpoint.billingDetails.enabled &&
                  endpoint.billingDetails.pricingType &&
                  endpoint.billingDetails.value
                ) {
                  var doctorsPrice = this.user.billingDetails.enabled
                    ? this.user.billingDetails.amount
                    : 0;

                  var billingDetails = {
                    currency: this.user.billingDetails.currency,
                  };

                  //Calculate amount based on endpoints configuration
                  switch (endpoint.billingDetails.pricingType) {
                    case "fixedPrice":
                      billingDetails.amount = endpoint.billingDetails.value;
                      break;
                    case "fixedMargin":
                      billingDetails.amount =
                        parseInt(doctorsPrice) +
                        parseInt(endpoint.billingDetails.value);
                      break;
                    case "percentageMargin":
                      billingDetails.amount =
                        parseInt(doctorsPrice) +
                        parseInt(doctorsPrice) *
                          (parseInt(endpoint.billingDetails.value) / 100);
                      break;
                    default:
                      billingDetails.amount = doctorsPrice;
                  }
                }

                //Make this doctor as doctor for the appointment
                try {
                  appt = await this.$store.dispatch(
                    "updateDoctorForAppointment",
                    {
                      appointmentId: appt._id,
                      provider: provider,
                      billingDetails: billingDetails,
                    }
                  );

                  //Mark appointment as in-progress
                  try {
                    appt = await this.$store.dispatch("updateStatus", {
                      appointmentId: appt._id,
                      status: "InProgress",
                    });

                    socket.emit("appointmentJoined", {
                      appointmentId: appt._id,
                      userId: this.user._id,
                    });
                    socket.emit("appointmentJoined", {
                      appointmentId: appt._id,
                      endpointId: appt.endpoint,
                      userId: this.user._id,
                    });
                    socket.emit("appointmentJoined", {
                      appointmentId: appt._id,
                      specialityId: appt.specialityId,
                      userId: this.user._id,
                    });

                    console.log("settng", appt);
                    this.$store.commit("setState", {
                      stateName: "appointment",
                      stateValue: appt,
                    });

                    this.$router.push(telemedPage);
                  } catch (e) {
                    this.getAppointments();

                    if (e.code == "APPT_DELETED") {
                      swal.fire(this.$t("message.Appointment has been deleted"));
                    } else if (e.code == "APPT_CLOSED") {
                      swal.fire(this.$t("message.Appointment has been closed by the nurse"));
                    } else {
                      swal.fire({
                        title: this.$t("message.Appointment error"),
                        text: this.$t("message.Problem joining the appointment Contact Administrator"),
                        type: "error",
                        timer: 5000,
                      });
                    }
                  }
                } catch (e) {
                  this.getAppointments();

                  //If appointment is already responded by another provider
                  if (e.code && e.code == "APPT_RESPONDED") {
                    swal.fire({
                      title: this.$t("message.Appointment info"),
                      text: this.$t("message.Appointment was responded by another doctor"),
                      type: "info",
                      timer: 5000,
                    });
                  } else {
                    swal.fire({
                      title: this.$t("message.Appointment error"),
                      text: this.$t("message.Problem joining the appointment Contact Administrator"),
                      type: "error",
                      timer: 5000,
                    });
                  }
                }
              }

              //If this provider is the primary provider for the appointment
              else if (this.user._id == appt.provider.providerId) {
                try {
                  //Get endpoint details assigned to appointment
                  let endpoint = await this.$store.dispatch(
                    "getEndpoint",
                    appt.endpoint
                  );
                  appt = await this.$store.dispatch("updateStatus", {
                    appointmentId: appt._id,
                    status: "InProgress",
                  });

                  //If doctor's endpoint is SPARK_EMBEDDED
                  if (this.user.endpoint.videoConfEPType == "SPARK_EMBEDDED") {
                    this.loaderText = this.$t("message.Loading Webex Please wait It may take a minute");
                    //Get remote user
                    try {
                      let remoteUser = await this.$store.dispatch(
                        "getUserById",
                        appt.user
                      );

                      if (
                        this.appointment.consultationType == "telemed-direct" &&
                        this.settings.directTelemedicine.videoConfType ==
                          "WEBEX_TEAMS"
                      ) {
                        requestData.members.push({
                          isGuest: true,
                          participantEmail:
                            remoteUser.webexTeams.guestParticipantEmail,
                          participantId:
                            remoteUser.webexTeams.guestParticipantId,
                        });

                        //Creating Webex room
                        this.setupResponse = await this.$store.dispatch(
                          "createWebexRoom",
                          requestData
                        );
                      } else {
                        let requestData = {
                          userId: this.user._id,
                          appointmentId: appt._id,
                          members: [],
                        };

                        if (endpoint.videoConfEPType == "WEBEXTEAMS_GUEST") {
                          requestData.members.push({
                            isGuest: true,
                            participantEmail:
                              remoteUser.webexTeams.guestParticipantEmail,
                            participantId:
                              remoteUser.webexTeams.guestParticipantId,
                          });
                        } else {
                          requestData.members.push({
                            isGuest: false,
                            participantEmail:
                              endpoint.videoConfDetails.phoneNumber ||
                              remoteUser.email,
                          });
                        }

                        //Creating Webex room
                        this.setupResponse = await this.$store.dispatch(
                          "createWebexRoom",
                          requestData
                        );
                      }

                      console.log(
                        "setupResponse.triggerCallDelay",
                        this.setupResponse.triggerCallDelay
                      );
                      setTimeout(async () => {
                        let res = await this.$store.dispatch(
                          "triggerCall",
                          appt
                        );
                        console.log("triggerwebex", res);

                        if (res && res.responseCode != 200) {
                          this.LOADING = false;
                          swal.fire({
                            text: this.$t("message.Unable to load webex Please contact adminstrator"),
                            type: "error",
                            timer: 5000,
                          });
                          try {
                            await this.$store.dispatch(
                              "deleteWebexRoom",
                              appt._id
                            );

                            await this.$store.dispatch("updateEndPointStatus", {
                              endpointId: endpoint._id,
                              status: "Free",
                            });
                          } catch (e) {
                            console.error(e);
                          }
                        } else {
                          socket.emit("appointmentJoined", {
                            appointmentId: appt._id,
                            userId: this.user._id,
                          });
                          socket.emit("appointmentJoined", {
                            appointmentId: appt._id,
                            endpointId: appt.endpoint,
                            userId: this.user._id,
                          });

                          console.log("settng", appt);

                          let appointment = await this.$store.dispatch(
                            "getAppointment",
                            appt._id
                          );

                          await this.$store.commit("setState", {
                            stateName: "appointment",
                            stateValue: appointment,
                          });

                          this.$router.push(telemedPage);
                        }
                      }, this.setupResponse.triggerCallDelay);

                      /*socket.emit("joinRoom", {
                      type: "appointment",
                      id: appt._id,
                    });*/
                    } catch (e) {
                      console.log(e);
                    }
                  } else {
                    // in app appointmentJoined is being received twice.
                    // socket.emit("appointmentJoined", {
                    //   appointmentId: appt._id,
                    //   userId: this.user._id,
                    // });
                    socket.emit("appointmentJoined", {
                      appointmentId: appt._id,
                      endpointId: appt.endpoint,
                      userId: this.user._id,
                    });

                    this.$store.commit("setState", {
                      stateName: "appointment",
                      stateValue: appt,
                    });
                    this.$router.push(telemedPage);
                  }
                } catch (err) {
                  if (err.code == "APPT_DELETED") {
                    swal.fire(this.$t("message.Appointment has been deleted"));
                  } else {
                    swal.fire(this.$t("message.Error joining appointment"));
                  }
                  this.$emit("appointment-declined");
                  this.LOADING = false;
                }
              }

              //If this provider is the secondary provider for the appointment
              else if (this.user._id != appt.provider.providerId) {
                var isSecondaryProvider = false;
                appt.secondaryProviders.forEach(async function (provider) {
                  if (
                    provider.providerId == this.user._id &&
                    !isSecondaryProvider
                  ) {
                    isSecondaryProvider = true;

                    try {
                      await this.$store.dispatch(
                        "updateStatusSecondaryProvider",
                        {
                          appointmentId: appt._id,
                          providerId: provider.providerId,
                          status: "joined",
                        }
                      );

                      socket.emit("appointmentJoined", {
                        appointmentId: appt._id,
                        userId: this.user._id,
                      });
                      socket.emit("appointmentJoined", {
                        appointmentId: appt._id,
                        endpointId: appt.endpoint,
                        userId: this.user._id,
                      });

                      console.log("settng", appt);
                      this.$store.commit("setState", {
                        stateName: "appointment",
                        stateValue: appt,
                      });

                      this.$router.push(telemedPage);
                    } catch (e) {
                      console.log(e);
                    }
                  }

                  if (!isSecondaryProvider) {
                    this.getAppointments();
                    swal.fire({
                      title: "Info",
                      text:
                        this.$t("message.Appointment was responded by Dr") +
                        appt.provider.firstName +
                        " " +
                        appt.provider.lastName,
                      timer: 2000,
                      type: "info",
                    });
                  }
                });
              }
            }
          } else if (appt && appt.appointmentType == "Scheduled") {
            //Mark appointment as in-progress
            try {
              if (this.user._id == appt.provider.providerId) {
                try {
                  appt = await this.$store.dispatch("updateStatus", {
                    appointmentId: appt._id,
                    status: "InProgress",
                  });

                  //If doctor's endpoint is SPARK_EMBEDDED
                  this.loaderText =
                    this.appointment.consultationType == "telemed-direct" &&
                    this.settings.directTelemedicine.videoConfType ==
                      "WEBEX_TEAMS"
                      ? this.$t("message.Loading Webex Please wait It may take a minute")
                      : this.$t("message.Setting up WEBEX room for this appointment");
                  if (this.user.endpoint.videoConfEPType == "SPARK_EMBEDDED") {
                    //Get remote user
                    try {
                      let requestData = {
                        userId: this.user._id,
                        appointmentId: appt._id,
                        members: [],
                      };

                      let remoteUser = await this.$store.dispatch(
                        "getUserById",
                        appt.user
                      );

                      if (
                        this.appointment.consultationType == "telemed-direct" &&
                        this.settings.directTelemedicine.videoConfType ==
                          "WEBEX_TEAMS"
                      ) {
                        requestData.members.push({
                          isGuest: true,
                          participantEmail:
                            remoteUser.webexTeams.guestParticipantEmail,
                          participantId:
                            remoteUser.webexTeams.guestParticipantId,
                        });

                        console.log(requestData);

                        //Creating Webex room
                        await this.$store.dispatch(
                          "createWebexRoom",
                          requestData
                        );
                      } else {
                        //Get endpoint details assigned to appointment
                        let endpoint = await this.$store.dispatch(
                          "getEndpoint",
                          appt.endpoint
                        );

                        let requestData = {
                          userId: this.user._id,
                          appointmentId: appt._id,
                          members: [],
                        };

                        //If remote user's endpoint is SPARK_EMBEDDED
                        if (endpoint.videoConfEPType == "SPARK_EMBEDDED") {
                          requestData.members.push({
                            isGuest: false,
                            participantEmail:
                              endpoint.videoConfDetails.phoneNumber ||
                              remoteUser.email,
                          });
                        }

                        //If remote user's endpoint is WEBEXTEAMS_GUEST
                        else if (
                          endpoint.videoConfEPType == "WEBEXTEAMS_GUEST"
                        ) {
                          requestData.members.push({
                            isGuest: true,
                            participantEmail:
                              remoteUser.webexTeams.guestParticipantEmail,
                            participantId:
                              remoteUser.webexTeams.guestParticipantId,
                          });
                        }

                        //Creating Webex room
                        await this.$store.dispatch(
                          "createWebexRoom",
                          requestData
                        );
                      }
                      this.$store.commit("setState", {
                        stateName: "appointment",
                        stateValue: appt,
                      });

                      //Added Timeout to fix webex call not connecting issue, doctor has to join after 30 sec timeout and patient has to join after docter to make video call work
                      if (
                        this.appointment.consultationType == "telemed-direct" &&
                        this.settings.directTelemedicine.videoConfType ==
                          "WEBEX_TEAMS"
                      ) {
                        setTimeout(() => {
                          this.$router.push(telemedPage);
                        }, 30000);
                      } else {
                        socket.emit("appointmentJoined", {
                          appointmentId: appt._id,
                          endpointId: appt.endpoint,
                          userId: this.user._id,
                        });
                        socket.emit("appointmentJoined", {
                          appointmentId: appt._id,
                          specialityId: appt.specialityId,
                          userId: this.user._id,
                        });
                        this.$router.push(telemedPage);
                      }
                    } catch (e) {
                      console.log(e);
                    }
                  } else {
                    socket.emit("appointmentJoined", {
                      appointmentId: appt._id,
                      userId: this.user._id,
                    });
                    socket.emit("appointmentJoined", {
                      appointmentId: appt._id,
                      endpointId: appt.endpoint,
                      userId: this.user._id,
                    });

                    this.$store.commit("setState", {
                      stateName: "appointment",
                      stateValue: appt,
                    });
                    this.$router.push(telemedPage);
                  }
                } catch (err) {
                  if (err.code == "APPT_DELETED") {
                    swal.fire(this.$t("message.Appointment has been deleted"));
                  } else {
                    swal.fire(this.$t("message.Error joining appointment"));
                  }
                  this.$emit("appointment-declined");
                  this.LOADING = false;
                }
              }
            } catch (e) {
              if (e.code == "APPT_DELETED") {
                swal.fire(this.$t("message.Appointment has been deleted"));
              } else {
                swal.fire({
                  title: this.$t("message.Appointment error"),
                  text: this.$t("message.Problem joining the appointment Contact Administrator"),
                  type: "error",
                  timer: 5000,
                });
              }
            }
          } else {
            this.loading = false;
            this.getAppointments();
            swal.fire({
              title: this.$t("message.Appointment error"),
              text: this.$t("message.Problem joining the appointment Contact Administrator"),
              type: "error",
              timer: 5000,
            });
          }
        }
      } catch (e) {
        console.log(e);
        this.LOADING = false;
      }
    },
    viewAppointmentDetails(appointment) {
      this.$store.commit("setState", {
        stateName: "appointment",
        stateValue: appointment,
      });

      this.$router.push("viewappointmentdetails");
    },
    declineVisit(appoinment) {
      swal
        .fire({
          title: this.$t("message.Are you sure?"),
          text: this.$t("message.You will not be able to take this appointment later!"),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: this.$t("message.Yes, decline it!"),
          closeOnConfirm: true,
        })
        .then(async (isConfirm) => {
          if (isConfirm.value) {
            this.loader = this.$loading.show({
              container: null,
              canCancel: false,
            });

            try {
              let appt = await this.$store.dispatch(
                "getAppointment",
                appoinment._id
              );
              if (appt) {
                //If appoinment is for speciality
                if (!appt.provider || !appt.provider.providerId) {
                  $http
                    .put(
                      "/appointments/update/declinedBy/" + appt._id,
                      { providerId: this.user._id },
                      { timeout: this.canceler.promise }
                    )
                    .success(function (data, status, headers, config) {
                      appt.declinedBy = data.declinedBy;
                      appt.__v = data.__v;
                      this.$emit("appointment-declined");

                      //Retrieve all providers for appointment's speciality
                      $http
                        .get("/providers/bySpeciality/" + appt.specialityId, {
                          timeout: this.canceler.promise,
                        })
                        .success(function (providers) {
                          //If all doctors of speciality have declined, mark appointment as Declined
                          if (appt.declinedBy.length == providers.length) {
                            $http
                              .put(
                                "/appointments/update/status/" + appt._id,
                                { appointmentStatus: "Declined" },
                                { timeout: this.canceler.promise }
                              )
                              .success(function (
                                data,
                                status,
                                headers,
                                config
                              ) {
                                this.loading = false;
                                appt.appointmentStatus = data.appointmentStatus;
                                appt.__v = data.__v;
                                socket.emit("appointmentDeclined", {
                                  appointmentId: appointmentId,
                                  providerId: this.user._id,
                                });
                              })
                              .error(function (err) {
                                this.loading = false;
                                console.log(
                                  "Error marking appointment as declined"
                                );
                              });
                          }
                        })
                        .error(function (err) {
                          this.loading = false;
                          swal(this.$t("message.Error getting speciality details"));
                        });
                    })
                    .error(function (data, status, headers, config) {
                      this.loading = false;
                    });
                }

                //If this provider is primary provider for the appoinment
                else if (
                  appt.provider &&
                  appt.provider.providerId == this.user._id
                ) {
                  appt.latestStatus = "Declined";

                  await this.$store.dispatch("updateStatus", {
                    appointmentId: appt._id,
                    status: appt.latestStatus,
                  });

                  if (appt.appointmentType == "Scheduled") {
                    this.$emit("appointment-declined");
                    socket.emit("appointmentDeclined", {
                      endpointId: appt.endpoint,
                    });
                  } else if (appt.appointmentType == "Live") {
                    this.$emit("appointment-declined");
                  }
                  socket.emit("appointmentDeclined", {
                    appointmentId: appt._id,
                    providerId: this.user._id,
                  });
                  this.$emit("appointment-declined");
                }

                //If this provider is secondary provider for the appointment
                else if (
                  appt.secondaryProviders &&
                  appt.secondaryProviders.length > 0
                ) {
                  appt.secondaryProviders.forEach(function (provider) {
                    var done = false;

                    if (provider.providerId == this.user._id && !done) {
                      $http
                        .put(
                          "/appointments/update/provider/secondary/status/" +
                            appt._id,
                          {
                            providerId: provider.providerId,
                            status: "declined",
                          }
                        )
                        .success(function (data) {
                          socket.emit("appointmentDeclined", {
                            appointmentId: appt._id,
                            providerId: this.user._id,
                          });
                          this.$emit("appointment-declined");
                        })
                        .error(function (err) {
                          this.loading = false;
                        });

                      done = true;
                    }
                  });
                }
                this.loader.hide();
              } else {
                this.$emit("appointment-declined");
              }
            } catch (e) {
              this.loader.hide();
              console.log(e);
            }
          }
        });
    },
  },
};
</script>

<style scoped>
/deep/ .vld-icon {
  text-align: center;
}
.call-ripple {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 50px;
  border-radius: 100%;
  background: #fff;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.25);
  z-index: 1;
  background-color: #18ce0f;
  color: white;
}
.call-ripple span {
  position: relative;
  font-size: 72px;
  height: 100%;
  width: 100%;
}
.call-ripple::after {
  opacity: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
  inset-inline-end: 0;
  bottom: 0;
  content: "";
  height: 100%;
  width: 100%;
  border: 8px solid rgba(0, 0, 0, 0.2);
  border-radius: 100%;
  animation-name: ripple;
  animation-duration: 3s;
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.65, 0, 0.34, 1);
  z-index: -1;
}
.call-ripple::before {
  opacity: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
  inset-inline-end: 0;
  bottom: 0;
  content: "";
  height: 100%;
  width: 100%;
  border: 8px solid rgba(0, 0, 0, 0.2);
  border-radius: 100%;
  animation-name: ripple;
  animation-duration: 3s;
  animation-delay: 0.5s;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.65, 0, 0.34, 1);
  z-index: -1;
}
@keyframes ripple {
  from {
    opacity: 1;
    transform: scale3d(0.75, 0.75, 1);
  }
  to {
    opacity: 0;
    transform: scale3d(1.5, 1.5, 1);
  }
}
</style>
